export default __webpack_public_path__ + "static/media/icon-company-d.7f119021.svg";